
export class VectorGraphics {
    static errorImage(name = 'Photo', backgroundColor = '#F2F2F200', textColor = '#878787') {
        const svg =
            `<?xml version="1.0" encoding="utf-8"?>
                <!-- Generator: Adobe Illustrator 27.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" width="100" height="100">
                <style type="text/css">
                    .st0{fill:${backgroundColor};}
                    .st1{fill:none;}
                    .st2{fill:${textColor};}
                    .st3{font-family:"Helvetica"}
                    .st4{font-size:7px;}
                    .st5{fill:none;stroke:${textColor};stroke-width:1.5;stroke-miterlimit:10;}
                </style>
                <rect class="st0" width="100" height="100"/>
                <text transform="translate(30.5 60)"><tspan x="0" y="0" class="st2 st3 st4">${name} is not </tspan><tspan x="5" y="10" class="st2 st3 st4">available</tspan></text>
                <circle class="st5" cx="50" cy="40" r="8"/>
                <line class="st5" x1="44" y1="46" x2="56" y2="35"/>
                </svg>
            `
        //return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg)
        return 'data:image/svg+xml;base64,' + btoa(svg)
    }

    static earthDataLogo(colorEarth = '#A0C819', colorData = '#0F1E50', backgroundColor = '#0000') {
        const svg =
            `<?xml version="1.0" encoding="utf-8"?>
                <!-- Generator: Adobe Illustrator 27.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 348.8 204" style="enable-background:new 0 0 348.8 204;" xml:space="preserve">
                <style type="text/css">
                    .st0{fill:${colorEarth};}
                    .st1{fill:${colorData};}
                    .st2{fill:${backgroundColor};}
                </style>
                <rect class="st2" width="100%" height="100%"/>
                <path class="st0" d="M74.3,85.9H54.6V74.4h18.3V61.1H54.6v-9.6h19.8V38.3H38.1v55.8c0,0,14.2-2.2,36.3-3.6V85.9z"/>
                <path class="st0" d="M181.7,72.7c6.9-3.9,10.4-9.3,10.4-16.4c0-12-8.3-18-24.9-18h-20v52c5.4,0.4,10.9,0.8,16.5,1.4V77.1h4.2
                    l9.4,16.2c5.7,0.8,11.5,1.7,17.2,2.8c1.1,0.2,2.2,0.4,3.3,0.6L181.7,72.7z M175.3,62.7c-7.9,11.4-19.1,6.3-19.1,6.3
                    c-2.2-0.3-3.2,3.6-3.2,3.6C152,73.9,151,73,151,73c0.7-3.7,2.5-5.3,2.5-5.3c15.4-5.6,18.7-14,18.7-14c-6.5,8.7-19.4,13.3-19.4,13.3
                    c-3.5-13.8,9.7-18.9,15.5-19c5.8-0.1,8.4-2.3,8.4-2.3C180.1,55,175.3,62.7,175.3,62.7z"/>
                <path class="st0" d="M99.2,89.3l0.4-1.4h19.8l0.3,1.3c5.7,0.1,11.6,0.2,17.5,0.5l-17-51.7h-22L81.4,90C87,89.7,93,89.5,99.2,89.3z
                    M108,55.1c0.7-3.3,1.2-5.6,1.5-7c0.3,1.5,0.9,4.1,1.7,7.6c0.9,3.5,1.6,6.4,2.2,8.6l2.6,10h-13C105.6,64.8,107.2,58.4,108,55.1z"/>
                <path class="st0" d="M215.4,99.3c5.6,0.7,11.1,1.2,16.5,1.6V51.8h14.9V38.3h-46.3v13.5h14.9V99.3z"/>
                <path class="st0" d="M272.1,101.7V74.4h19.2v26.3c5.9-0.4,11.4-0.9,16.6-1.5v-61h-16.6v22.6h-19.2V38.3h-16.6v63.6
                    C261.2,101.9,266.8,101.9,272.1,101.7z"/>
                <path class="st1" d="M75,103.1c-22.9,2.4-37.4,5.4-37.4,5.4V164h20.6c10.6,0,18.8-2.9,24.6-8.6c5.8-5.7,8.8-13.9,8.8-24.5
                    c0-9.9-2.8-17.4-8.3-22.6C81,106,78.2,104.3,75,103.1z M70.1,145.4c-2.4,3-6.3,4.5-11.5,4.5h-3.8v-35.6h5c4.7,0,8.2,1.4,10.5,4.2
                    c2.3,2.8,3.5,7.1,3.5,13C73.8,137.7,72.6,142.3,70.1,145.4z"/>
                <path class="st1" d="M117,100.4L96.3,164h18.9l3.2-11.9H139l3.1,11.9H161l-21-63.7C132.1,100.1,124.4,100.2,117,100.4z M121.9,138
                    c2.6-10,4.3-16.7,5.1-20.1c0.8-3.4,1.3-5.8,1.5-7.3c0.3,1.6,0.9,4.2,1.8,7.9c0.9,3.7,1.7,6.7,2.3,9l2.7,10.4H121.9z"/>
                <path class="st1" d="M176.4,103.8c-4.3-0.7-8.7-1.3-13.2-1.8v12.4h15.5V164h17.2v-49.6h15.5v-5.2C200.8,107.9,189.9,106,176.4,103.8
                    z"/>
                <path class="st1" d="M246.2,111.9c0.3,1.6,0.9,3.8,1.6,6.7c0.9,3.7,1.7,6.7,2.3,9l2.7,10.4h-13.5c2.6-10,4.3-16.7,5.1-20
                    c0.6-2.6,1-4.6,1.3-6.1c-3.2-0.1-6.3-0.3-9.4-0.5c-1.9-0.1-3.7-0.1-5.5-0.2L213.6,164h18.9l3.2-11.9h20.7l3.1,11.9h18.8l-16.7-51.7
                    C256.3,112.2,251.1,112.1,246.2,111.9z"/>
                </svg>
        `
        return 'data:image/svg+xml;base64,' + btoa(svg)
    }

    static marineDataLogo(colorMarine = '#00AFB9', colorData = '#1F284C', backgroundColor = '#0000') {
        const svg =
            `<?xml version="1.0" encoding="utf-8"?>
                <!-- Generator: Adobe Illustrator 27.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 450.3 204" style="enable-background:new 0 0 450.3 204;" xml:space="preserve">
                <style type="text/css">
                    .st0{fill:${colorMarine};}
                    .st1{fill:${colorData};}
                    .st2{fill:${backgroundColor};}
                </style>
                <rect class="st2" width="100%" height="100%"/>
                <g>
                    <g>
                        <path class="st0" d="M260.5,110.8c0.6,2.4,1.1,4.7,1.7,6.9c0.6,2.2,1,3.9,1.3,5.1l2.9,11.1h-14.4l2.9-11.1
                            c0.4-1.5,0.9-3.3,1.4-5.5c0.5-2.2,1.1-4.5,1.6-6.7c0.1-0.5,0.2-0.9,0.3-1.3c-5.2-0.6-10.5-1.2-15.8-2l-17.6,54.3h20l3.4-12.6h21.9
                            l3.3,12.6h19.9l-16.7-50.7c-5.5-0.3-11-0.8-16.7-1.4C260.3,109.9,260.4,110.3,260.5,110.8z"/>
                    </g>
                    <g>
                        <path class="st0" d="M171.4,96.1V109h16.5v52.6h18.2V109h16.4v-5.3c-1-0.2-1.9-0.4-2.9-0.6C203.1,99.6,186.9,97.4,171.4,96.1z"/>
                    </g>
                    <g>
                        <path class="st0" d="M121.9,95.3l-21.5,66.2h20l3.4-12.6h21.9l3.3,12.6H169L147.1,95C138.4,94.8,130,95,121.9,95.3z M127.6,134
                            l2.9-11.1c0.4-1.5,0.9-3.3,1.4-5.5c0.5-2.2,1.1-4.5,1.6-6.7c0.5-2.3,0.9-4.2,1.2-5.7c0.3,1.5,0.7,3.5,1.3,5.9
                            c0.6,2.4,1.1,4.7,1.7,6.9c0.6,2.2,1,3.9,1.3,5.1L142,134H127.6z"/>
                    </g>
                    <g>
                        <path class="st0" d="M38.3,161.6h21.8c7.2,0,13.4-1.3,18.7-3.9c5.3-2.6,9.4-6.5,12.4-11.7c2.9-5.2,4.4-11.7,4.4-19.6
                            c0-7-1.3-12.8-3.9-17.6c-2.2-4.1-5.4-7.4-9.4-9.8c-21.1,2.9-36.6,6.7-44,8.7V161.6z M61.8,108.8c3.3,0,6.1,0.7,8.3,2
                            c2.2,1.3,3.8,3.4,4.9,6c1.1,2.7,1.6,6.1,1.6,10.2c0,6.6-1.3,11.5-3.9,14.8c-2.6,3.2-6.6,4.8-12.2,4.8h-4.1v-37.8H61.8z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path class="st1" d="M368.8,97.7c24.4-2.8,39.4-6.5,39.4-6.5v-5.7h-21.5V73h19.9V58.6h-19.9V48.2h21.5V33.8h-39.4V97.7z"/>
                    </g>
                    <g>
                        <path class="st1" d="M339.9,100.2h14.5v-1.1C349.8,99.5,345,99.9,339.9,100.2z"/>
                        <path class="st1" d="M354.4,33.8h-16v30c0,1.5,0,3.3,0.1,5.2c0.1,2,0.2,3.9,0.3,5.8c0.1,1.9,0.2,3.6,0.3,5.1h-0.3l-24.2-46.2
                            h-23.4v66.4h15.9V70.3c0-1.7,0-3.5-0.1-5.6c-0.1-2.1-0.2-4.1-0.3-6.1c-0.1-2-0.3-3.7-0.4-5.1h0.4l24.3,46.8h9
                            c5.1-0.3,9.9-0.7,14.5-1.1V33.8z"/>
                    </g>
                    <g>
                        <path class="st1" d="M276.8,33.8h-18v64.5c6.1,0.7,12.1,1.2,18,1.6V33.8z"/>
                    </g>
                    <g>
                        <path class="st1" d="M233.4,71.3c2.3-1.3,4.3-2.8,6-4.6c1.7-1.7,3-3.7,3.9-5.9c0.9-2.2,1.4-4.7,1.4-7.4c0-4.3-1-8-3-10.9
                            c-2-2.9-5-5.1-9-6.6c-4-1.5-9-2.2-15-2.2h-21.8v53.8c5.9,0.9,11.9,2,17.9,3.2V76h4.5l10.3,17.7c7.5,1.4,14.9,2.6,22.2,3.5
                            L233.4,71.3z M223.9,60.7c-1.8,1.2-4,1.8-6.8,1.8h-3.4V47.4h3.5c3.2,0,5.6,0.6,7,1.8c1.5,1.2,2.2,2.9,2.2,5
                            C226.5,57.3,225.6,59.5,223.9,60.7z"/>
                    </g>
                    <g>
                        <path class="st1" d="M166.7,33.5h-23.9l-16,49.1c17.6-0.1,36.9,0.8,57.2,3.3L166.7,33.5z M147.9,73l2.9-10.9
                            c0.4-1.5,0.9-3.3,1.4-5.5c0.5-2.2,1-4.4,1.5-6.6c0.5-2.2,0.9-4.1,1.2-5.6c0.3,1.5,0.7,3.4,1.3,5.8c0.6,2.3,1.1,4.6,1.7,6.8
                            c0.6,2.2,1,3.9,1.3,5.1L162,73H147.9z"/>
                    </g>
                    <g>
                        <path class="st1" d="M113.9,33.8H90L76.4,80.9h-0.4L62.2,33.8H38.3v58.1c3.5-0.8,8.9-1.9,15.9-3.1V71.4c0-2.3-0.1-4.6-0.2-7.1
                            c-0.1-2.5-0.3-4.7-0.4-6.9c-0.1-2.1-0.3-3.8-0.4-5h0.4l9.9,35c7.3-1.1,15.8-2.1,25.2-2.9l9-32h0.4c-0.1,1.2-0.2,2.9-0.3,5.1
                            c-0.1,2.1-0.2,4.4-0.3,6.8c-0.1,2.4-0.1,4.7-0.1,6.7v12.7c5.3-0.4,10.8-0.7,16.5-0.8V33.8z"/>
                    </g>
                </g>
                </svg>
            `
        return 'data:image/svg+xml;base64,' + btoa(svg)
    }

    static o2aDataLogo(colorCircles = "#01729C", colorO2A = "#1AA9E1", textColor = "#01729C", backgroundColor = '#0000') {
        const svg =
            `<?xml version="1.0" encoding="utf-8"?>
                <!-- Generator: Adobe Illustrator 27.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 415 257" style="enable-background:new 0 0 415 257;" xml:space="preserve">
                <style type="text/css">
                    .st0{fill:${colorO2A};}
                    .st1{fill:${colorCircles};}
                    .st2{font-family:'Montserrat-SemiBold';}
                    .st3{font-size:19.514px;}
                    .st4{fill:${textColor};}
                    .st5{fill:${backgroundColor};}
                </style>
                <rect class="st5" width="100%" height="100%"/>
                <path class="st0" d="M175.9,200.2h-52.6c-2.2,0-4.2-1.2-5.3-3l-26.3-45.5c-1.1-1.9-1.1-4.2,0-6.1l26.3-45.5c1.1-1.9,3.1-3,5.3-3
                    h52.6c2.2,0,4.2,1.2,5.3,3l26.3,45.5c1.1,1.9,1.1,4.2,0,6.1l-26.3,45.5C180.1,199,178.1,200.2,175.9,200.2z M134.7,179.7h29.8
                    c1.9,0,3.6-1,4.6-2.6l14.9-25.8c0.9-1.6,0.9-3.7,0-5.3l-14.9-25.8c-0.9-1.6-2.7-2.6-4.6-2.6h-29.8c-1.9,0-3.6,1-4.6,2.6l-14.9,25.8
                    c-0.9,1.6-0.9,3.7,0,5.3l14.9,25.8C131.1,178.7,132.8,179.7,134.7,179.7z"/>
                <path class="st0" d="M363.6,200.2h29.7l-44.7-101h-28.1l-34.6,78.3h-0.4h-6.1h-32.9l19.1-17.6c4.8-4.4,8.4-8.4,10.9-12
                    c2.5-3.6,4.1-7,5-10.2c0.9-3.2,1.3-6.5,1.3-9.7c0-6.3-1.7-11.7-5-16.3c-3.3-4.6-7.9-8.2-13.8-10.7c-5.9-2.5-12.7-3.8-20.5-3.8
                    c-9.9,0-18.4,1.9-25.5,5.8c-3.2,1.7-9.6,6.6-11.7,9l11.9,19.7c2.1-1.8,5.8-5.5,12.5-8.9c3.2-1.6,6.6-2.5,10.2-2.5
                    c4.3,0,7.6,0.9,9.7,2.7c2.2,1.8,3.2,4.4,3.2,7.6c0,1.3-0.2,2.8-0.6,4.4c-0.4,1.6-1.3,3.3-2.6,5.3c-1.3,1.9-3.3,4.1-6,6.6l-37.8,35.3
                    v17.9h69.1h3.5h6.1H302h3l7.9-19.6h42.8L363.6,200.2z M321.4,159.5l13-32.3l13,32.3H321.4z"/>
                <path class="st1" d="M151.9,84.8h-29.6c-1.2,0-2.4-0.7-3-1.7l-14.8-25.6c-0.6-1.1-0.6-2.4,0-3.4l14.8-25.6c0.6-1.1,1.7-1.7,3-1.7
                    h29.6c1.2,0,2.4,0.7,3,1.7L169.7,54c0.6,1.1,0.6,2.4,0,3.4L154.9,83C154.3,84.1,153.2,84.8,151.9,84.8z M128.7,73.2h16.8
                    c1.1,0,2-0.6,2.6-1.5l8.4-14.5c0.5-0.9,0.5-2.1,0-3l-8.4-14.5c-0.5-0.9-1.5-1.5-2.6-1.5h-16.8c-1.1,0-2,0.6-2.6,1.5l-8.4,14.5
                    c-0.5,0.9-0.5,2.1,0,3l8.4,14.5C126.7,72.7,127.7,73.2,128.7,73.2z"/>
                <path class="st1" d="M83.5,130.6H42.6c-1.7,0-3.3-0.9-4.1-2.4L18.1,92.9c-0.8-1.5-0.8-3.3,0-4.7l20.4-35.3c0.8-1.5,2.4-2.4,4.1-2.4
                    h40.8c1.7,0,3.3,0.9,4.1,2.4L108,88.2c0.8,1.5,0.8,3.3,0,4.7l-20.4,35.3C86.7,129.7,85.2,130.6,83.5,130.6z M51.5,114.7h23.2
                    c1.5,0,2.8-0.8,3.6-2.1l11.6-20c0.7-1.3,0.7-2.8,0-4.1l-11.6-20c-0.7-1.3-2.1-2.1-3.6-2.1H51.5c-1.5,0-2.8,0.8-3.6,2.1l-11.6,20
                    c-0.7,1.3-0.7,2.8,0,4.1l11.6,20C48.6,113.9,50,114.7,51.5,114.7z"/>
                <text transform="matrix(1 0 0 1 117.3736 236.2347)" class="st4 st2 st3">Data Flow Framework</text>
                </svg>`
        return 'data:image/svg+xml;base64,' + btoa(svg)
    }
}